import { render, staticRenderFns } from "./goodsLimitSet.vue?vue&type=template&id=06382056&scoped=true&"
import script from "./goodsLimitSet.vue?vue&type=script&lang=js&"
export * from "./goodsLimitSet.vue?vue&type=script&lang=js&"
import style0 from "./goodsLimitSet.vue?vue&type=style&index=0&id=06382056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06382056",
  null
  
)

component.options.__file = "goodsLimitSet.vue"
export default component.exports